import { ShopperHomePage } from "./../shopper-home/shopper-home";
import { ShopperMissionSocialPage } from "./../shopper-mission-social/shopper-mission-social";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Storage } from "@ionic/storage";
import { ServiceProvider } from "./../../providers/service/service";
import { Http, RequestOptions, Headers } from "@angular/http";
import { TranslateService } from "@ngx-translate/core";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  AlertController,
  LoadingController,
} from "ionic-angular";
import { ShopperBuySocialPlazalistPage } from "../shopper-buy-social-plazalist/shopper-buy-social-plazalist";
import { ShopperSocialGroupJoinInputPage } from "../shopper-social-group-join-input/shopper-social-group-join-input";

@IonicPage()
@Component({
  selector: "page-shopper-mission-social-desc",
  templateUrl: "shopper-mission-social-desc.html",
})
export class ShopperMissionSocialDescPage {
  code: string = "";
  mission_no = "";
  data = {
    mission_text: "",
    participants_no: "",
    shopper_no: "",
    mission_condition_1_th: "",
    mission_condition_1_en: "",
    mission_condition_2_th: "",
    mission_condition_2_en: "",
    mission_condition_3_th: "",
    mission_condition_3_en: "",
    social_mission: "",
  };
  // public qrData = null;
  public createdCode: string = null;
  members: any;
  membersCheck = 0;
  step = 0;
  url: any;
  budget: any;

  condition1 = "";
  condition2 = "";
  condition3 = "";
  theme = 1;
  // interval: any;
  social_group: number;
  leader_social_group: any;
  mission_text: "";

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService,
    public alertCtrl: AlertController,
    private loadingCtrl: LoadingController
  ) {
    this.mission_no = this.navParams.data.id;
    this.mission_text = this.navParams.data.mission_text;
    this.social_group = this.navParams.data.social_group;
    this.leader_social_group = this.navParams.data.leader_social_group;

    // this.interval = setInterval(() => {
    //   this.storage.get("token").then((token) => {
    //     this.storage.get("info").then((info) => {
    //       this.storage.get("language").then((lang) => {
    //         var headers = new Headers();
    //         headers.append("Accept", "application/json");
    //         headers.append("Authorization", "Bearer " + token);
    //         const requestOptions = new RequestOptions({ headers: headers });

    //         var link2 =
    //           this.services.URLShopperMissions +
    //           "/" +
    //           this.mission_no +
    //           "/members";
    //         this.http
    //           .get(link2, requestOptions)
    //           .map((res) => res.json())
    //           .subscribe(
    //             (data) => {
    //               this.members = data;
    //               this.membersCheck = data.length;
    //             },
    //             (error) => {
    //               var response = JSON.parse(error._body);

    //               this.translateService
    //                 .get(response.message)
    //                 .subscribe((value) => {
    //                   this.services.presentToast(value);
    //                 });
    //             }
    //           );

    //         if (info.role == 1) {
    //           this.url = this.services.URLPlazaStatBudgets;
    //         } else if (info.role == 2) {
    //           this.url = this.services.URLMerchantStatBudgets;
    //         } else if (info.role == 3) {
    //           this.url = this.services.URLShopperStatBudgets;
    //         }
    //       });
    //     });
    //   });
    // }, 3000);
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("currentStep").then((step) => {
      this.step = step;
    });

    this.storage.get("token").then((token) => {
      this.storage.get("info").then((info) => {
        this.storage.get("language").then((lang) => {
          var link = this.services.URLShopperMissions + "/" + this.social_group;
          var headers = new Headers();
          headers.append("Accept", "application/json");
          headers.append("Authorization", "Bearer " + token);
          const requestOptions = new RequestOptions({ headers: headers });

          this.http
            .get(link, requestOptions)
            .map((res) => res.json())
            .subscribe(
              (data) => {
                this.data = data;

                if (lang == "th") {
                  this.condition1 = this.data.mission_condition_1_th;
                  this.condition2 = this.data.mission_condition_2_th;
                  this.condition3 = this.data.mission_condition_3_th;
                } else {
                  this.condition1 = this.data.mission_condition_1_en;
                  this.condition2 = this.data.mission_condition_2_en;
                  this.condition3 = this.data.mission_condition_3_en;
                }

                // this.qrData = {
                //   mission_no: this.mission_no,
                //   user_id: info.id,
                // };
                // this.createdCode = JSON.stringify(this.qrData);
                loader.dismiss();
              },
              (error) => {
                var response = JSON.parse(error._body);

                this.translateService
                  .get(response.message)
                  .subscribe((value) => {
                    this.services.presentToast(value);
                  });
                loader.dismiss();
              }
            );

          if (this.leader_social_group != "") {
            var link2 =
              this.services.URLShopperMissions +
              "/" +
              this.leader_social_group +
              "/members";
            this.http
              .get(link2, requestOptions)
              .map((res) => res.json())
              .subscribe(
                (data) => {
                  this.members = data;
                  this.membersCheck = data.length;
                },
                (error) => {
                  var response = JSON.parse(error._body);

                  this.translateService
                    .get(response.message)
                    .subscribe((value) => {
                      this.services.presentToast(value);
                    });
                }
              );
          }

          if (info.role == 1) {
            this.url = this.services.URLPlazaStatBudgets;
          } else if (info.role == 2) {
            this.url = this.services.URLMerchantStatBudgets;
          } else if (info.role == 3) {
            this.url = this.services.URLShopperStatBudgets;
          }
          var link4 = this.url;

          this.http
            .get(link4, requestOptions)
            .map((res) => res.json())
            .subscribe(
              (data) => {
                this.budget = this.services.currencyFormat(data.available);
              },
              (error) => {
                // console.log(error);
                this.services.presentToastInternet();
              }
            );
        });
      });
    });
  }

  /** getCode for new function */
  getCode() {
    this.storage.get("token").then((token) => {
      var link = this.services.URLShopperMissionsCode;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .post(
          link,
          {
            social_group: this.social_group,
          },
          requestOptions
        )
        .map((res) => res.json())
        .subscribe(
          (data) => {
            console.log(data);
            this.code = data.code;
          },
          (error) => {
            var response = JSON.parse(error._body);

            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });
  }

  doRefresh(refresher) {
    this.code = "";
    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("currentStep").then((step) => {
      this.step = step;
    });

    this.storage.get("token").then((token) => {
      this.storage.get("info").then((info) => {
        this.storage.get("language").then((lang) => {
          var link = this.services.URLShopperMissions + "/" + this.social_group;
          var headers = new Headers();
          headers.append("Accept", "application/json");
          headers.append("Authorization", "Bearer " + token);
          const requestOptions = new RequestOptions({ headers: headers });

          this.http
            .get(link, requestOptions)
            .map((res) => res.json())
            .subscribe(
              (data) => {
                this.data = data;

                if (lang == "th") {
                  this.condition1 = this.data.mission_condition_1_th;
                  this.condition2 = this.data.mission_condition_2_th;
                  this.condition3 = this.data.mission_condition_3_th;
                } else {
                  this.condition1 = this.data.mission_condition_1_en;
                  this.condition2 = this.data.mission_condition_2_en;
                  this.condition3 = this.data.mission_condition_3_en;
                }

                if (data.leader_social_group != "") {
                  var link2 =
                    this.services.URLShopperMissions +
                    "/" +
                    data.leader_social_group +
                    "/members";
                  this.http
                    .get(link2, requestOptions)
                    .map((res) => res.json())
                    .subscribe(
                      (data) => {
                        this.members = data;
                        this.membersCheck = data.length;
                      },
                      (error) => {
                        var response = JSON.parse(error._body);

                        this.translateService
                          .get(response.message)
                          .subscribe((value) => {
                            this.services.presentToast(value);
                          });
                      }
                    );
                }

                // this.qrData = {
                //   mission_no: this.mission_no,
                //   user_id: info.id,
                // };
                // this.createdCode = JSON.stringify(this.qrData);
                loader.dismiss();
              },
              (error) => {
                var response = JSON.parse(error._body);

                this.translateService
                  .get(response.message)
                  .subscribe((value) => {
                    this.services.presentToast(value);
                  });
                loader.dismiss();
              }
            );

          if (info.role == 1) {
            this.url = this.services.URLPlazaStatBudgets;
          } else if (info.role == 2) {
            this.url = this.services.URLMerchantStatBudgets;
          } else if (info.role == 3) {
            this.url = this.services.URLShopperStatBudgets;
          }
          var link4 = this.url;

          this.http
            .get(link4, requestOptions)
            .map((res) => res.json())
            .subscribe(
              (data) => {
                this.budget = this.services.currencyFormat(data.available);
              },
              (error) => {
                // console.log(error);
                this.services.presentToastInternet();
              }
            );
        });
      });
    });

    refresher.complete();
  }

  remove(user_id) {
    const confirm = this.alertCtrl.create({
      // title: 'Remove this shop?',
      message: "You want remove this member?",
      buttons: [
        {
          text: "Yes",
          handler: () => {
            const loader = this.loadingCtrl.create({
              content: "Loading...",
            });
            loader.present();

            this.storage.get("token").then((token) => {
              var link =
                this.services.URLShopperMissions +
                "/" +
                this.leader_social_group +
                "/members";

              const options = {
                headers: new Headers({
                  Accept: "application/json",
                  Authorization: "Bearer " + token,
                }),
                body: {
                  user_id: user_id,
                },
              };

              this.http
                .delete(link, options)
                .map((res) => res.json())
                .subscribe(
                  (data) => {
                    loader.dismiss();
                    this.navCtrl.push(ShopperMissionSocialDescPage, {
                      social_group: this.social_group,
                      id: this.mission_no,
                      mission_text: this.mission_text,
                      leader_social_group: this.leader_social_group,
                    });
                  },
                  (error) => {
                    var response = JSON.parse(error._body);
                    loader.dismiss();
                    this.translateService
                      .get(response.message)
                      .subscribe((value) => {
                        this.services.presentToast(value);
                      });
                  }
                );
            });
          },
        },
        {
          text: "No",
          cssClass: "btn-no",
          handler: () => {
            // console.log('Disagree clicked');
          },
        },
      ],
    });
    confirm.present();
  }

  ionViewDidLeave() {
    // clearInterval(this.interval);
  }

  buy() {
    this.navCtrl.push(ShopperBuySocialPlazalistPage, {
      social_mission: this.data.social_mission,
      social_group: this.social_group,
    });
  }

  join() {
    // this.navCtrl.push(ShopperSocialGroupJoinScanPage, {
    //   mission_id: this.mission_no,
    // });
    /** แก้ qr code */
    this.navCtrl.push(ShopperSocialGroupJoinInputPage, {
      social_mission: this.data.social_mission,
      social_group: this.social_group,
      mission_text: this.mission_text,
    });
  }

  copyToClipboard = (): boolean => {
    const el = document.createElement("textarea");
    el.value = this.code;
    el.setAttribute("readonly", "");
    // el.style = { position: "absolute", left: "-9999px" };
    document.body.appendChild(el);

    el.select();
    // Copy text to clipboard
    try {
      const successful = document.execCommand("copy");
      if (successful) {
        document.body.removeChild(el);
        // copy to clipboard
        this.services.presentToast("copied!");
        return true;
      }
    } catch (err) {
      return false;
    }

    return false;
  };

  backPage() {
    this.navCtrl.push(ShopperMissionSocialPage);
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.setRoot(ShopperHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopper-mission-social-desc/shopper-mission-social-desc.ts